import {accountTypes} from '@bdswiss/common-enums'
import {isPammManagerAccount} from '../../../common/utils/accounts'
import {Account} from '../../../graphql/types'

/**
 * Whether the account being created is a PAMM money manager account, and so must
 * carry an explicit PAMM Terms & Conditions acceptance before it can be created
 * (PT-5857). `accountType` is the wizard's raw selection, which is empty until
 * the user picks a type.
 */
export const requiresPammTermsAcceptance = (accountType?: string): boolean => {
  if (!accountType || !accountTypes[accountType]) return false
  return isPammManagerAccount({__typename: accountType} as Account)
}
